import React from "react";

export const CreatePostInfoIcon = ({ color = "#1E22FF" }) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M11.5833 6.625L7.5 11.5469H10.4167V15.375L14.5 10.4531H11.5833V6.625Z"
          fill={color}
          stroke={color}
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8686 5.7498C15.8053 4.56143 14.4062 3.72388 12.8565 3.34794C11.3068 2.97201 9.6795 3.0754 8.18984 3.64444C6.70017 4.21349 5.41837 5.22137 4.51398 6.53476C3.60959 7.84815 3.12524 9.40515 3.125 10.9998V11.6561"
          stroke={color}
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.13135 16.25C6.19469 17.4384 7.59375 18.2759 9.14345 18.6519C10.6932 19.0278 12.3205 18.9244 13.8101 18.3554C15.2998 17.7863 16.5816 16.7784 17.486 15.465C18.3904 14.1517 18.8747 12.5946 18.875 11V10.3438"
          stroke={color}
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9062 12.3125L18.875 10.3438L20.8438 12.3125"
          stroke={color}
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.09375 9.6875L3.125 11.6562L1.15625 9.6875"
          stroke={color}
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="21" height="21" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
